import { MinLocationBase } from "../core/global";
import { ApiResponse, err, getAxios, postAxios, res } from "./axios";

export const getAllUserLocations = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations`, false)
    const response = result?.data?.locations || null
    return res(response)
  } catch {
    return err("Error fetching locations data.")
  }
}

interface UpdateLocationProps {
  title: string
  notes: string
  uid: number
}

export const updateLocation = async ({
  title,
  notes,
  uid,
}: UpdateLocationProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/locations/update`, {
      title,
      notes,
      uid,
    }, false)

    const response = result?.data?.location || null
    return res(response)
  } catch {
    return err("Error updating location data.")
  }
}

interface AddLocationProps extends MinLocationBase {

}

export const addLocation = async ({
  title,
  notes,
}: AddLocationProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/locations/add`, {
      title,
      notes
    }, false)

    const uid = result?.data?.uid || null
    return res({uid})
  } catch {
    return err("Error adding location data.")
  }
}

interface ToggleLocationProps {
  uid: number
  visible: boolean
}

export const toggleLocation = async ({
  uid,
  visible,
}: ToggleLocationProps):Promise<ApiResponse> => {

  try {
    const result = await postAxios(`/api/v1/locations/toggle`, {
      uid,
      visible
    }, false)

    const _visible = result?.data?.visible || false
    return res({visible: _visible})
  } catch {
    return err("Error adding location data.")
  }
}

interface GetUserLocationsShapesProps {
  uid: number
}

export const getUserLocationsShapes = async ({
  uid,
}: GetUserLocationsShapesProps):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations/get-shapes/${uid}`, false)

    const response = result?.data?.shapes || null
    return res(response)
  } catch {
    return err("Error fetching location shapes data.")
  }
}



interface RemoveSavedLocationShapeProps {
  uid: number | string
}

export const removeSavedLocationShape = async ({
  uid,
}: RemoveSavedLocationShapeProps):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations/remove-shape/${uid}`, false)

    const response = result?.data?.shapes || null
    return res(response)
  } catch {
    return err("Error deleting location shapes data.")
  }
}


interface removeSavedLocationShapeProps {
  uid: number
}

export const removeSavedLocation = async ({
  uid,
}: removeSavedLocationShapeProps):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations/remove/${uid}`, false)

    const response = result?.data?.shapes || null
    return res(response)
  } catch {
    return err("Error deleting location data.")
  }
}

interface AddSavedLocationShapeProps {
  uid: number
  title: string
  data: string
  source: string
  hidden?: boolean
  color?: string
}

export const addSavedLocationShape = async ({
  uid,
  title,
  data,
  source,
  hidden,
  color,
}: AddSavedLocationShapeProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/locations/add-shape/${uid}`, {
      title,
      data,
      source,
      hidden,
      color
    }, false)

    const response = result?.data?.shape || null
    return res(response)
  } catch {
    return err("Error inserting location shape data.")
  }
}

interface GetVivibleLocationShapesProps {
  uid?: number | null,    // user uid
}

export const getVisibleLocationShapes = async ({
  uid,
}: GetVivibleLocationShapesProps):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations/get-visible-shapes/${uid ? uid : ''}`, false)

    const response = result?.data?.shapes || null
    return res(response)
  } catch {
    return err("Error getting location shape data.")
  }
}


interface GetShapeInfoProps {
  shape_uid: number | null,    // user uid
}

export const getShapeInfo = async ({
  shape_uid
}: GetShapeInfoProps):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations/get-shape-info/${shape_uid}`, false)

    return res({
      ...result?.data
    })
  } catch {
    return err("Error getting location shape info.")
  }
}


interface GetVisibleLocationShapesInfoProps {
  uid?: number | null,    // user uid
}

export const getVisibleLocationShapesInfo = async ({
  uid
}: GetVisibleLocationShapesInfoProps):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/locations/get-visible-shapes-info/${uid ? uid : ''}`, false)

    return res({
      result: result?.data?.result || null
    })
  } catch {
    return err("Error getting location shape data.")
  }
}


interface UpdateLocationShapeProps {
  color?: string
  title?: string
  hidden?: boolean
  uid: number | string
}

export const updateLocationShape = async ({
  color,
  title,
  hidden,
  uid,
}: UpdateLocationShapeProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/locations/update-shape`, {
      color,
      title,
      hidden,
      uid,
    }, false)

    const response = result?.data?.location || null
    return res(response)
  } catch {
    return err("Error updating location shape.")
  }
}